// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import WheelTooltip from 'WheelTooltip';

/* eslint-disable react/no-unused-prop-types */
type WheelActItemProps = {
  hide: PropTypes.bool.isRequired,
  act: PropTypes.string.isRequired,
  entityLabel: PropTypes.string.isRequired,
  fieldSubtitle: PropTypes.string.isRequired,
  entityUrl: {
    alias: PropTypes.string.isRequired,
  },
};

const WheelActItem = ({
  hide,
  act,
  entityLabel,
  fieldSubtitle,
  entityUrl,
}: WheelActItemProps): React.Element<any> =>
  (<Link
    to={entityUrl.alias}
    className={`btn btn--pop center center--both${hide ? ' is-hidden' : ''}`}
    onMouseDown={event => {
      // Prevent focus.
      event.preventDefault();
    }}
  >
    <span
      className={`btn${act === ''
        ? ' btn--dot'
        : ''} btn--act center center--both`}
    >
      <span className="btn__child">
        {act}
      </span>
    </span>
    <span className="btn__pop btn btn--default btn--small btn--circle btn--radiating center center--both">
      <span className="svg-wrapper icon--tiny center center--both theme--white">
        <svg aria-hidden="true" focusable="false">
          <use xlinkHref="#icon-play" />
        </svg>
      </span>
    </span>
    <WheelTooltip entityLabel={entityLabel} fieldSubtitle={fieldSubtitle} />
  </Link>);
/* eslint-enable react/no-unused-prop-types */

export default WheelActItem;



// WEBPACK FOOTER //
// ./screens/App/components/WheelActItem/index.js